import { useRef } from "react";
import { motion, useSpring } from "framer-motion";

export const MagneticButton = ({ children, className = "", strength = 20 }) => {
  const ref = useRef(null);
  const x = useSpring(0, { stiffness: 160, damping: 14, mass: 0.4 });
  const y = useSpring(0, { stiffness: 160, damping: 14, mass: 0.4 });

  const onMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    x.set(((e.clientX - r.left) / r.width - 0.5) * strength);
    y.set(((e.clientY - r.top) / r.height - 0.5) * strength);
  };

  const onLeave = () => {
    x.set(0);
    y.set(0);
  };

  return (
    <motion.div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      style={{ x, y }}
      className={`inline-block ${className}`}
    >
      {children}
    </motion.div>
  );
};
